import { makeStyles } from "@mui/styles"

const useStyle = makeStyles(() => ({
  rowChecked: {
    borderRadius: 8,
    cursor: "pointer",
    backgroundColor: "#ececec",
    "& #kebab": {
      color: "#263057",
    },
  },
  row: {
    borderRadius: 8,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#ececec",
      "& #kebab": {
        color: "#263057",
      },
    },
  },
  cuit: {
    height: 44,
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    color: "#6e7a76",
    textAlign: "center",
    textOverflow: "ellipsis",
    width: "15%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    "@media all and (max-width: 600px)": {
      fontSize: 12,
      padding: "0px 10px",
    },
  },
  date: {
    height: 44,
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    color: "#6e7a76",
    textAlign: "center",
    textOverflow: "ellipsis",
    width: "20%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    "@media all and (max-width: 1090px)": {
      display: "none",
    },
  },
  status: {
    height: 44,
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    color: "#6e7a76",
    textAlign: "center",
    textOverflow: "ellipsis",
    width: "10%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    "@media all and (max-width: 1090px)": {
      display: "none",
    },
  },
  name: {
    height: 44,
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    color: "#6e7a76",
    textAlign: "center",
    textOverflow: "ellipsis",
    width: "25%",
    maxWidth: "200px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    "@media all and (max-width: 600px)": {
      fontSize: 12,
    },
  },

  user: {
    height: 44,
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    color: "#6e7a76",
    textAlign: "center",
    textOverflow: "ellipsis",
    width: "32%",
    maxWidth: "200px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    "@media all and (max-width: 1090px)": {
      display: "none",
    },
    "@media all and (max-width: 600px)": {
      fontSize: 12,
    },
  },
  note: {
    height: 44,
    fontFamily: "Roboto",
    fontSize: 14,
    marginRight: "3%",
    fontWeight: "bold",
    color: "#6e7a76",
    textAlign: "center",
    textOverflow: "ellipsis",
    width: "40%",
    maxWidth: "200px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    "@media all and (max-width: 600px)": {
      fontSize: 12,
    },
  },
  itemKebab: {
    height: 44,
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#2C3532",
    width: "10%",
    cursor: "pointer",
    textAlign: "center",
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    "&:hover": {
      backgroundColor: "#ececec",
    },
  },
  kebab: {
    color: "#B3B3B3",
  },
  fieldValueDisabled: {
    color: "#d1cfcb",
  },
  stepperStyleSeeMore: {
    width: 500,
    height: "100vh",
    backgroundColor: "#fff",
  },
  boxStyle: {
    padding: "10px",
  },
  boxTypography: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  typographyStyle: {
    fontSize: "14px",
  },
  hoverButtonRotate: {
    transition: "transform 0.2s ease",
  },
  drawerContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  drawerHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 24px",
    backgroundColor: "#f8f9fa",
  },
  drawerTitle: {
    fontWeight: 600,
    color: "#333",
  },
  closeButton: {
    color: "#666",
  },
  drawerContent: {
    flex: 1,
    padding: "24px",
    overflowY: "auto",
  },
  section: {
    marginBottom: "32px",
  },
  sectionTitle: {
    fontWeight: 600,
    color: "#333",
    marginBottom: "16px",
  },
  field: {
    marginBottom: "16px",
  },
  fieldLabel: {
    fontSize: "12px",
    fontWeight: 600,
    color: "#666",
    textTransform: "uppercase",
    marginBottom: "4px",
  },
  fieldValue: {
    fontSize: "14px",
    color: "#333",
  },
  actionButtons: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  actionText: {
    fontSize: "14px",
    color: "#666",
  },
}))

export default useStyle
